import { createFeatureSelector, createSelector } from '@ngrx/store'
import { DesignationState } from './designation.state'

export const selectDesignationState = createFeatureSelector<DesignationState>('designation')

// Selector to get the total count of businesses
export const selectTotalCount = createSelector(
  selectDesignationState,
  (state: DesignationState) => {
    return state.totalCount
  }
)

// export const selectDesignationId = createSelector(selectDesignationState, (state: designationState) =>
//   state.designations.length > 0 ? state.designations[state.designations.length - 1].id : null
// )
